var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84131 10.167C11.0504 10.167 12.8413 8.37613 12.8413 6.16699C12.8413 3.95785 11.0504 2.16699 8.84131 2.16699C6.63217 2.16699 4.84131 3.95785 4.84131 6.16699C4.84131 8.37613 6.63217 10.167 8.84131 10.167Z",
    stroke: "#475569",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77881 13.6666C3.39314 12.6023 4.27683 11.7185 5.34103 11.104C6.40523 10.4895 7.61244 10.166 8.84131 10.166C10.0702 10.166 11.2774 10.4895 12.3416 11.104C13.4058 11.7185 14.2895 12.6023 14.9038 13.6666",
    stroke: "#475569",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3);
export default __webpack_public_path__ + "static/media/user3.fd7b7896b73b2cf3f02abcdbe09aab2e.svg";
export { ForwardRef as ReactComponent };